import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect , NavLink } from "react-router-dom";
import { setAlert } from "../../actions/alert";
import PropTypes from "prop-types";

const FindCyber = () => {
  return (
    <section className="main-find-services pt-0">
        
        <div className="container">
      <div class="v2_198">
        <div className="Mainheading">
        <span class="v2_199"><span style={{color: "#2F327D"}}>Why</span> <span style={{color: "#23BDEE"}}>CybertoCyber?</span></span>
            <div class="v2_201"></div>
            <div class="v2_200"></div> 
        </div>
        
      <div className="col1">
        <span class="v2_202">A world of top cybersecurity professionals at your service.</span>
        <div class="v2_203"></div>
        <div class="v2_204"></div>
        <div class="v2_205"></div>
        <span class="v2_206">On-demand, trustworthy, and dedicated experts to address your cybersecurity problems.</span>
        <div class="v2_207">
            <div class="v2_208"></div>
            <div class="v2_209"></div>
            <div class="v2_210"></div>
            <div class="v2_211"></div>
        </div>
        <span class="v2_212">Freedom for clients and professionals to work together.</span>
        <div class="v2_213">
            <div class="v2_214"></div>
            <div class="v2_215"></div>
        </div>
        <div class="v2_216">
            <div class="v2_217"></div>
        </div>
        </div>

        {/*Mid section starts*/}
        <div class="v2_223">
            <div class="v2_224"></div>
            <div class="v2_225"></div>
            <div class="v2_226"></div>
            <div class="v2_227"></div>
        </div>

        {/*Seperate right section starts*/}
        <div className="col2">
            {/*first */}
            <span class="v2_222">Seamless process for job posting and project bidding.</span>
            <div class="v2_219"></div> 
            <div class="v2_228">
                <div class="v2_229"></div>
                <div class="v2_230"></div>
                <div class="v2_231"></div>
                <div class="v2_232"></div>
            </div>

            {/*2nd */}
            <span class="v2_233">Satisfaction of clients and professionals is our first priority.</span>
            <div class="v2_220"></div>
            <div class="v2_234">
                <div class="v2_235"></div>
                <div class="v2_236"></div>
            </div>

            {/*3rd */}
            <span class="v2_218">Committed to providing the best services that no one offers.</span>
            <div class="v2_221"></div>
            <div class="v2_237">
                <div class="v2_238"></div>
            </div>
        </div>
        </div>
        </div>
        
    </section>
  );
};


export default connect()(FindCyber);